export default "__VITE_ASSET__CAbZk32g__"